export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const showNotification = ({ title, body, icon, data }) => {
  if (!('Notification' in window)) {
    console.log('Ce navigateur ne prend pas en charge les notifications de bureau');
    return;
  }

  if (Notification.permission === 'granted') {
    try {
      const notification = new Notification(title, {
        body,
        icon: icon || '/logo192.png',
        data,
      });

      notification.onclick = function(event) {
        event.preventDefault();
        if (this.data?.url) {
          window.open(this.data.url, '_blank');
        }
        window.focus();
        this.close();
      };
    } catch (error) {
      console.error('Error showing notification:', error);
    }
  }
};

export const handleNewMessage = (message, userSettings) => {
  if (!userSettings.notifications?.enabled) return;

  const title = message.contact_name || message.contact_number;
  let body = '';

  switch (message.message_type) {
    case 'text':
      body = message.content;
      break;
    case 'image':
      body = message.metadata?.caption || 'Image reçue';
      break;
    case 'video':
      body = message.metadata?.caption || 'Vidéo reçue';
      break;
    case 'audio':
      body = 'Message vocal reçu';
      break;
    case 'document':
      body = `Document reçu: ${message.metadata?.filename || ''}`;
      break;
    default:
      body = 'Nouveau message reçu';
  }

  showNotification({
    title,
    body: body.length > 100 ? body.substring(0, 97) + '...' : body,
    data: {
      url: `/conversations/${message.conversation_id}`,
      messageId: message.id,
    },
  });
};
